import React from "react";
import { useNavigate } from "react-router-dom";
import "./CreateBlogMenu.css";
import Button from "../../../Components/Button/Button";

const CreateBlogMenu = ({
  searchFunction,
  clearSearch,
  currentCount,
  totalCount,
  isBlogSliceFetchingSmall,
  handleSaveDraft,
  handlePreview,
  handleSubmit,
  isEditing,
  lastSavedAt,
  draftStatus,
}) => {
  const navigate = useNavigate();

  return (
    <header className="createBlogHeader">
      <div className="secondMenu flexbox">
        <div className="SmenuLeft">
          <nav className="cbBreadcrumb" aria-label="Breadcrumb">
            <button
              type="button"
              className="cbBreadcrumbLink"
              onClick={() => navigate("/")}
            >
              Blogs
            </button>
            <span className="cbBreadcrumbSep" aria-hidden="true">/</span>
            <span className="cbBreadcrumbCurrent">
              {isEditing ? "Edit Blog" : "Create Blog"}
            </span>
          </nav>

          <h1 className="cbPageTitle">
            {isEditing ? "Edit Blog" : "Create a new blog"}
          </h1>

          <div className="cbMetaRow">
            {draftStatus && (
              <span className={`cbStatusPill ${draftStatus.toLowerCase()}`}>
                <span className="cbStatusDot" aria-hidden="true"></span>
                {draftStatus}
              </span>
            )}
            {lastSavedAt && (
              <span className="cbLastSaved">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12 6v6l4 2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
                Last saved {lastSavedAt}
              </span>
            )}
          </div>
        </div>

      

        <div className="SmenuRight newButtonWrap">
          {handlePreview && (
            <Button
              onClick={handlePreview}
              className={"GhostButton iconButton"}
              name={"Preview"}
            />
          )}
          <Button
            onClick={handleSaveDraft}
            className={"GreyBorderButton iconButton"}
            name={"Save Draft"}
            isWaiting={isBlogSliceFetchingSmall}
          />
        </div>
      </div>
    </header>
  );
};

export default CreateBlogMenu;
